import { REGISTRATION_MESSAGE_TYPES, type RegistrationMessageType } from "./model";

export type RegistrationBridgeMessage =
  | {
      type: typeof REGISTRATION_MESSAGE_TYPES.REDIRECT_TO_LOGIN;
      payload?: undefined;
    }
  | {
      type: typeof REGISTRATION_MESSAGE_TYPES.REDIRECT_TO_PROFILE;
      payload?: undefined;
    }
  | {
      type: typeof REGISTRATION_MESSAGE_TYPES.REGISTRATION_SUCCESS;
      payload: { emailAddress: string; canLogin?: boolean };
    }
  | {
      type: typeof REGISTRATION_MESSAGE_TYPES.DISPLAY_ERROR_MODAL;
      payload: { title?: string; content: string };
    }
  | {
      type: typeof REGISTRATION_MESSAGE_TYPES.REDIRECT_TO_URI;
      payload: { uri: string };
    };

export type RegistrationBridgeLike = {
  postMessage: (message: string) => void;
};

export function serializeRegistrationBridgeMessage(message: RegistrationBridgeMessage): string {
  return JSON.stringify(message);
}

export function isRegistrationMessageType(v: string): v is RegistrationMessageType {
  return Object.values(REGISTRATION_MESSAGE_TYPES).includes(v as RegistrationMessageType);
}
